import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_members_form_field_email = _resolveComponent("members-form-field-email")!
  const _component_members_form_field_firstname = _resolveComponent("members-form-field-firstname")!
  const _component_members_form_field_lastname = _resolveComponent("members-form-field-lastname")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_members_form_field_password = _resolveComponent("members-form-field-password")!
  const _component_members_form_field_job_title = _resolveComponent("members-form-field-job-title")!
  const _component_members_form_field_organization = _resolveComponent("members-form-field-organization")!
  const _component_members_form_field_allow_marketing = _resolveComponent("members-form-field-allow-marketing")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, {
    greedy: "",
    onSubmit: _ctx.onSubmit,
    class: "q-gutter-md",
    ref: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_members_form_field_email, {
        modelValue: _ctx.memberModel.email,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.memberModel.email) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_members_form_field_firstname, {
        modelValue: _ctx.memberModel.firstName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.memberModel.firstName) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_members_form_field_lastname, {
        modelValue: _ctx.memberModel.lastName,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.memberModel.lastName) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_checkbox, {
        modelValue: _ctx.withPassword,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.withPassword) = $event)),
        label: "Create member with password"
      }, null, 8, ["modelValue"]),
      (_ctx.withPassword)
        ? (_openBlock(), _createBlock(_component_members_form_field_password, {
            key: 0,
            modelValue: _ctx.memberModel.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.memberModel.password) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_members_form_field_job_title, {
        modelValue: _ctx.memberModel.jobTitleId,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.memberModel.jobTitleId) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_members_form_field_organization, {
        modelValue: _ctx.memberModel.organizationId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.memberModel.organizationId) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_members_form_field_allow_marketing, {
        modelValue: _ctx.memberModel.allowMarketingCommunication,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.memberModel.allowMarketingCommunication) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_btn, {
        label: "Add member",
        type: "submit",
        color: "primary",
        unelevated: "",
        "no-caps": ""
      })
    ]),
    _: 1
  }, 8, ["onSubmit"]))
}